import { render, staticRenderFns } from "./deliveryDetail.vue?vue&type=template&id=75868a71&scoped=true&"
import script from "./deliveryDetail.vue?vue&type=script&lang=js&"
export * from "./deliveryDetail.vue?vue&type=script&lang=js&"
import style0 from "./deliveryDetail.vue?vue&type=style&index=0&id=75868a71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75868a71",
  null
  
)

export default component.exports